import { type ReactNode } from 'react';
import type { Creator } from '@/types';
import { useMemberDisplay } from '@/hooks/use-member-display';
import { formatDate } from '../utils/creator-formatters';

function SoftDeletedBanner({ creator }: { creator: Creator }): ReactNode {
  const by = creator.expand?.deleted_by;
  const display = useMemberDisplay(by ?? { id: '' });
  const byName = by ? (display.fullName ?? display.name) : '';
  return (
    <div className="mb-base rounded-md border border-white/[0.08] bg-surface-elevated px-sm py-xs">
      <p className="text-[10px] uppercase tracking-wider text-text-tertiary">
        En papelera
      </p>
      <p className="mt-0.5 text-xs text-text-secondary">
        Eliminado {creator.deleted_at ? formatDate(creator.deleted_at) : ''}
        {byName ? ` por ${byName}` : ''}
      </p>
      {creator.delete_reason && (
        <p className="mt-0.5 text-xs text-text-primary">
          {creator.delete_reason}
        </p>
      )}
    </div>
  );
}

function VoidBanner({ creator }: { creator: Creator }): ReactNode {
  return (
    <div className="mb-base rounded-md border border-error/30 bg-error/10 px-sm py-xs">
      <p className="text-[10px] uppercase tracking-wider text-error">Anulado</p>
      {creator.void_reason && (
        <p className="mt-0.5 text-xs text-text-primary">
          {creator.void_reason}
        </p>
      )}
    </div>
  );
}

export function CreatorVoidWarning({
  creator,
}: {
  creator: Creator;
}): ReactNode {
  if (creator.deleted_at) return <SoftDeletedBanner creator={creator} />;
  if (creator.is_void) return <VoidBanner creator={creator} />;
  return null;
}
